export default "__VITE_ASSET__U8MIrxLE__"